import React from 'react';
import * as yup from 'yup';
import { useAppContext } from 'Context/ReactAppContext';
import { t } from 'Src/i18n';
import { internationalPhoneRegex, getPhoneRegex } from 'Utils/regex/RegexHelper';
import { useFormikContext } from 'formik';
import type { PaymentFormValues } from 'Src/types/payment';
import { castAs } from 'Src/types/cast-helpers';
import { PaymentFormikInput } from 'Components/widgets/payment-info/paymentFormik';
type VoxpayPhoneInputProps = {
  isDisabled?: boolean;
  withValidation?: boolean;
  fieldName: string;
};
export const VoxpayPhoneInput = ({
  isDisabled,
  fieldName,
  withValidation = true,
}: VoxpayPhoneInputProps) => {
  const formik = useFormikContext<PaymentFormValues>();
  const appContext = useAppContext();
  const phoneRegex = getPhoneRegex(appContext.locale);
  const validatePhone = yup
    .string()
    .matches(phoneRegex, t('booking.partners.linkPayment.sms.invalidNumber'))
    .matches(
      internationalPhoneRegex,
      t('booking.partners.linkPayment.sms.wrongFormatInternational'),
    )
    .required();
  return (
    <PaymentFormikInput
      isDisabled={isDisabled}
      name={fieldName}
      onChange={(e) =>
        formik.setFieldValue(
          fieldName,
          castAs<React.ChangeEvent<HTMLInputElement>>(e).target.value.trim(),
        )
      }
      label={t('common.form.labels.mobilePhoneNumber')}
      type="tel"
      validate={withValidation ? validatePhone : undefined}
    />
  );
};
